import styled from 'styled-components';

export const SpeakerContainer = styled.div`
    text-align: ${props => props.rtl ? 'left' : 'right'};
`;